import { Translate, useTranslate } from '~/i18n';
import Container from '../common/container';

import { Megaphone, ID, Calender } from '~/svgs/business';

const ReadyToSell = () => {
   const { translate } = useTranslate();

   const values = [
      {
         svg: <ID />,
         name: translate({ id: 'business:signup' }),
      },
      {
         svg: <Calender />,
         name: translate({ id: 'business:add' }),
      },
      {
         svg: <Megaphone />,
         name: translate({ id: 'business:start' }),
      },
   ];
   return (
      <Container>
         <div className="grid justify-items-center ">
            <div className="font-semibold text-[30px] lg:text-[60px] pt-12 lg:pt-[76px] pb-[14px] lg:pb-[20px] lg:px-32 text-center">
               <Translate id="business:ready to sell" />
            </div>
            <div className="text-[24px] lg:text-[38px] text-[#0552BC] lg:pb-[40px] pb-[14px]">
               <Translate id="business:get started" />
            </div>
            <div className="lg:grid lg:grid-cols-3 gap-20 justify-items-center">
               {values.map((value, key) => (
                  <div key={key} className="py-8">
                     <div className="flex justify-center">{value.svg}</div>
                     <div className="text-center pt-3">{value.name}</div>
                  </div>
               ))}
            </div>
         </div>
      </Container>
   );
};

export default ReadyToSell;
